export default function Footer() {
  return (
    <div className="footer">
      <p>Copyright Simpu Blog 2024 - All Right Reserved</p>
    </div>
  );
}
